import React, { useEffect, useState } from "react";
import { Modal, Tabs, Tab } from "react-bootstrap";
import Dropzone from "react-dropzone";
import { Variables } from "../../Variations/Variations";
import Util from "../../Classes/Util";
import Cookies from "js-cookie";
import { notifyError } from "../../Services/Notifier";

const CategoryGallery = ({ setMedia, setShowingMedia }) => {
    const permissions = Util.decrypt(localStorage.getItem("Permissions"));
    const token = Cookies.get("UserToken");

    const [show, setShow] = useState(false);
    const [fullscreen, setFullscreen] = useState(true);
    const [media, setMediaList] = useState([]);

    const fetchMedia = async () => {
        const res = await fetch(
            `${Variables.API_URL}UploadMedia/GetMedia`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const data = await res.json();
        setMediaList(data);
    };

    const handleDrop = async (files) => {
        let rejected = 0;

        for (let file of files) {
            if (file.size > 2000000) {
                rejected++;
                continue;
            }

            const formData = new FormData();
            formData.append("Image", file);

            try {
                const uploadRes = await fetch(
                    `${Variables.API_URL}UploadMedia/UploadImageToServer`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                        body: formData,
                    }
                );

                const imagePath = await uploadRes.text();

                if (imagePath) {
                    await fetch(`${Variables.API_URL}UploadMedia/InsertMedia`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            image: imagePath,
                            imageTitle: file.name.split(".").slice(0, -1).join("."),
                            altText: "",
                            description: "",
                            caption: "",
                        }),
                    });

                    fetchMedia();
                }
            } catch (e) {
                console.error(e);
            }
        }

        if (rejected > 0) {
            notifyError("Some images exceeded size limit (2MB)");
        }
    };

    useEffect(() => {
        fetchMedia();
    }, []);

    return (
        <>
            {/* TRIGGER */}
            <div className="media-picker" onClick={() => setShow(true)}>
                <div className="media-picker-content">
                    <i className="bi bi-image fs-2 text-primary"></i>
                    <div className="mt-2">
                        <strong>Select category image</strong>
                        <div className="text-muted small">
                            Upload or choose from media library
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL */}
            <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Select Category Image</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Tabs defaultActiveKey="Library" className="mb-3">

                        {permissions.ManageCategory && (
                            <Tab eventKey="Upload" title="Upload File">
                                <Dropzone onDrop={handleDrop} accept="image/*">
                                    {({ getRootProps, getInputProps }) => (
                                        <div {...getRootProps({ className: "dropzone" })}>
                                            <input {...getInputProps()} />
                                            <p style={{ height: 400 }}>
                                                Drag & drop image, or click to select
                                            </p>
                                        </div>
                                    )}
                                </Dropzone>
                            </Tab>
                        )}

                        <Tab eventKey="Library" title="Media Library">
                            <div
                                style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto",
                                    paddingRight: "10px",
                                }}
                            >
                                <div className="row">
                                    {media.map((img) => (
                                        <div className="col-2 p-2" key={img.MediaId}>
                                            <button
                                                className="btn-icon"
                                                onClick={() => {
                                                    setMedia(img.MediaId);
                                                    setShowingMedia(img.Image);
                                                    setShow(false);
                                                }}
                                            >
                                                <img
                                                    className="form-control"
                                                    src={Variables.API_PUBLISHED + img.Image}
                                                    alt=""
                                                />
                                            </button>
                                        </div>
                                    ))}

                                </div>
                            </div>
                        </Tab>


                    </Tabs>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CategoryGallery;
